import React from 'react';
import PropTypes from 'prop-types';

import PageHead from 'bdvp-common/src/components/Head';
import {
    getEmbedUrl,
    DateUtils,
    getVideoObjectSchema,
} from 'bdvp-common/src/utils';
import {
    useLang,
    useMediaConfigPlayback,
} from 'bdvp-common/src/hooks/config';

export const buildPageTitle = (data = {}, locale = 'en') => {

    const newTitle = (data?.title ?? data?.blurb) ?? '';
    const date = data?.date;
    const newDate = date ? ` | ${DateUtils.formatDate(date, locale, 'short')}` : '';

    return `${newTitle}${newDate}`;

};

const Head = (props) => {

    const { mediaItem } = props;
    const lang = useLang();
    const config = useMediaConfigPlayback();
    const { ogVideo = {} } = config;
    const { supportedPlaybacks = [], enabled = false } = ogVideo;
    let preferredPlayback;
    if(enabled) {

        preferredPlayback = mediaItem.playbacks?.find((playback) =>
            supportedPlaybacks.find((supportedPlayback) =>
                supportedPlayback === playback.name
            )
        );

    }

    return (
        <PageHead
            title={buildPageTitle(mediaItem, lang)}
            description={mediaItem.description}
            structuredData={getVideoObjectSchema(mediaItem, config, lang)}
            shareImage={(mediaItem.image?.cuts ?? []).find(cut => cut.width >= 1536)?.src ?? config.shareConfig?.defaultShareImg ?? ''}
            twitterCardData={{
                type: 'player',
                player: {
                    src: getEmbedUrl(mediaItem, config, lang),
                    width: config.shareConfig?.embedCode?.width ?? '560',
                    height: config.shareConfig?.embedCode?.height ?? '315',
                },
            }}
            {...preferredPlayback && {
                shareVideo: {
                    url: preferredPlayback.url,
                    secureUrl: preferredPlayback.url,
                    type: preferredPlayback.mimetype,
                },
            }}
        />
    );

};

Head.propTypes = {
    mediaItem: PropTypes.object.isRequired,
};

export default Head;
